import { RadioButtonsFilter } from '../../../Crud/filters/sharedBetweenFilters/types';
import { IFilterHelperFactory } from '../filter-factory.types';

class RadioFilterHelper implements IFilterHelperFactory {
  constructor(private readonly filter: RadioButtonsFilter) {}

  getChipLabel() {
    const selectedValue = this.filter.radioArgs.selectedValue;
    if (!selectedValue) {
      return '';
    }
    if (this.filter.customChipLabel) {
      return `${this.filter.title}: ${this.filter.customChipLabel}`;
    }
    const selectedOption = this.filter.radioArgs.options.find(
      (option) => option.value === selectedValue,
    );
    return `${this.filter.title}: ${selectedOption?.label}` || '';
  }

  getFriendlyLabel() {
    return this.getChipLabel();
  }

  hasValue() {
    return !!this.filter.radioArgs.selectedValue;
  }

  isLoading() {
    return false;
  }
}

export default RadioFilterHelper;
